import { createGetPropGetter } from '@/store/utils';

export default {
  issues: createGetPropGetter('issues', []),
  issueListOptions: createGetPropGetter('issueListOptions', {}),
  issuesListSort(state, { issueListOptions = {} }) {
    return issueListOptions.sort || {};
  },
  issuesInnerData: createGetPropGetter('issuesInnerData', {}),
  issueDetails: createGetPropGetter('issueDetails', {}),
};
